/*global $*/
import React from "react";
import { connect } from "react-redux";

import { validarPass } from "../gnp-login/services.act";
import { authentication } from "../app-database";
import { callService, goTo } from "../tools";

const mapState = (state) => {
	return {
		correo: state.login.correo,
		secreto: state.login.secreto,
		intento: state.login.intento,
		pUno: state.login.pUno,
		pUnoText: state.login.pUnoText,
		pDos: state.login.pDos,
		pDosText: state.login.pDosText,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
		accesoFamiliar: state.login.accesoFamiliar
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		pasoAnterior: () => {
			dispatch({ "type": "LOGIN_PASO_ANTERIOR" });
		},
		setCorreo: (correo) => {
			dispatch({ "type": "LOGIN_SET_CORREO", "correo": correo });
		},
		setSecreto: (secreto) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": secreto });
		},
		incrementaIntento: () => {
			dispatch({ "type": "LOGIN_INCREMENTA_INTENTO" });
		},
		resetPaso: () => {
			dispatch({ "type": "LOGIN_RESET_PASO" });
		},
		resetIntento: () => {
			dispatch({ "type": "LOGIN_RESET_INTENTO" });
		},
		pasoSiguiente: () => {
			dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
		},
		resetAccesoFamiliar: () => {
			dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": false });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		},
		alertaAccion: (sMensaje, fnAccion) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnAccion });
		}
	};
};

class IngresaContrasena extends React.Component {
	state = {
		inputType: "password",
		inputClass: "input-wrap mt-70",
		inputActive: "",
		error: false,
		errorMsj: "",
		pass: "",
		bloqueado: false
	}

	changeInputType = () => {
		let type = this.state.inputType;
		this.setState({ inputType: type == "password" ? "text" : "password" });
		this.setState({ inputClass: type == "password" ? "input-wrap visible-input mt-70" : "input-wrap ver-input mt-70" });
	}

	altaAccesoFamiliar = () => {
		let $this = this;
		let llamaServicio = new callService({
			service: "accesoFamiliar.loginInvitacion",
			secure: true,
			data: {
				hashOne: this.props.hashOne,
				hashTwo: this.props.hashTwo,
				email: this.props.accesoFamiliar
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.resetAccesoFamiliar();
			goTo("home");
			//window.location.href = '/#!/home';
			//$this.props.loader(false);
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alertaAccion(error.message.mensaje, () => {
				goTo("home");
				//window.location.href = '/#!/home';
			});
		});
	}

	validarPassW = () => {
		console.log("validarPass corriendo");
		let $this = this;
		$this.props.loader(true);

		this.setState({ bloqueado: true });
		console.log($("#pass-login").val());
		let pass = $("#pass-login").val();
		if (!pass) {
			$this.props.loader(false);
			this.setState({ error: true });
			this.setState({ errorMsj: "Campo requerido." });
			this.setState({ bloqueado: false });
			return;
		}
		validarPass("uid",this.props.correo, pass).then((response) => response.json()).then((responseJson) => {
			console.log("Función Validar Pass");
			console.log(responseJson);
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signOut().then(function () {
					console.log("Signed Out");
					authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
						//console.log(result);
						//$this.props.loader(false);
						localStorage.setItem("refreshToken", responseJson.refreshtoken);
						////////////////////////ACCESO FAMILIAR////////////////////////
						if ($this.props.accesoFamiliar != false) {
							$this.altaAccesoFamiliar();
						} else {
							goTo("home");
							//window.location.href = '/#!/home';
							//$this.props.loader(false);
						}
						///////////////////////////////////////////////////////////////
					}).catch(function (error) {
						console.log("signInWithCustomToken", error);
						$this.props.loader(false);
					});
				}, function (error) {
					console.error("Sign Out Error", error);
				});
			} else if (responseJson.hasOwnProperty("preguntas")) {
				$this.props.loader(false);
				/*console.log(this.props.intento);
				if(this.props.intento < 2) {
					$('#modal-primer-error').modal('toggle');
					this.refs.inputContrasena.value = "";
					this.setState({pass: ""});
				} else {
					this.props.resetIntento();
					$('#modal-bloqueado').modal('toggle');
				}*/
				if (!responseJson.preguntas) {
					$("#modal-primer-error").modal("toggle");
					this.refs.inputContrasena.value = "";
					this.setState({ pass: "" });
				} else {
					//this.props.resetIntento();
					$("#modal-bloqueado").modal("toggle");
				}
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente == "Inactivo") {
				$this.props.loader(false);
				$("#modal-user-bloqueado").modal("toggle");
			} else {
				this.props.alerta("Hubo un error al Loguearse. Favor de intentar más tarde.");
			}
		});
	}
	handleBlur = (event) => {
		let pass = event.target.value;
		this.setState({ pass: pass });
		this.setState({ inputActive: pass ? "input-active" : "" });
	}
	handleFocus = (event) => {
		this.setState({ inputActive: "input-active" });
		this.setState({ errorMsj: "" });
		event.target.value = this.state.error ? "" : event.target.value;
		this.setState({ error: false });
	}
	_handleKeyPress = (event) => {
		this.setState({ error: false });
		this.setState({ errorMsj: "" });
		if (event.key === "Enter") {
			this.setState({ bloqueado: true });
			if (!this.state.bloqueado) {
				console.log("Entro al enter 2");
				//this.setState({bloqueado: true});
				let pass = event.target.value;
				if (!pass) {
					this.setState({ error: true });
					this.setState({ errorMsj: "Campo requerido." });
					this.setState({ bloqueado: false });
					return;
				}
				this.validarPassW();
				// validarPass(pass).then((response) => response.json()).then((responseJson) => {
				//     if(responseJson.success) {
				//         // this.setState({bloqueado: false});
				//         window.location.href = '/#!/home';
				//     } else {
				//         if(this.props.intento < 2) {
				//             $('#modal-primer-error').modal('toggle');
				//             // this.refs.inputContrasena.value = "";
				//             // this.setState({bloqueado: false});
				//             // this.props.incrementaIntento();
				//         } else {
				//             this.props.resetIntento();
				//             $('#modal-bloqueado').modal('toggle');
				//             // this.setState({bloqueado: false});
				//         }
				//     }
				// });
			}
		}
	}
	siguientePregunta = () => {
		$("#modal-primer-error").modal("toggle");
		this.setState({ pass: "" });
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.incrementaIntento();
	}
	regresar = () => {
		this.props.setSecreto("");
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.pasoAnterior();
	}
	goToPreguntas = () => {
		$("#modal-bloqueado").modal("toggle");
		this.props.pasoSiguiente();
	}

	goToLogin = () => {
		$("#modal-user-bloqueado").modal("toggle");
		this.props.resetPaso();
	}

	componentDidMount = () => {
		var passw = document.getElementById("pass-login");
		passw.focus();
		passw.onpaste = function (e) {
			try { e.preventDefault(); } catch (o) { }
		};
	}

	ir = (sRuta) => {
		goTo(sRuta);
	}

	render() {
		return <div className="login-form">
			<div className="login-form">
				<h3 className="orange-text">Bienvenido</h3>
				<h3>{this.props.secreto}</h3>
				<div className={this.state.inputClass}>
					<label>Contraseña</label>
					<span className={this.state.inputActive}>
						<input id="pass-login" ref="inputContrasena" maxLength="24" name="contrasenia" type={this.state.inputType} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} />
					</span>
					{this.state.error &&
						<div className="error-wrap">
							<div className="msj-error">
								<p>{this.state.errorMsj}</p>
							</div>
						</div>
					}
				</div>
				<button name="continuar" onClick={this.validarPassW} disabled={this.state.bloqueado} className="orange-circle">
					<i></i>
				</button>
			</div>
			<div className="text-center other-actions clearfix">
				<a onClick={this.regresar} className="orange-btn">No soy yo</a>
				<a onClick={this.ir.bind(this, "olvide")}>Olvidé mi contraseña</a>
			</div>
			<div className="modal fade" id="modal-primer-error" tabIndex="-1" role="dialog" aria-labelledby="modal-primer-errorLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="">
							<h4 className="" id="modal-primer-errorLabel">Contraseña incorrecta</h4>
						</div>
						<div className="text-center">
							<p>Vuelve a ingresar tu contraseña.</p>
							<p>Por tu seguridad se bloqueará después de tres intentos fallidos.</p>
						</div>
						<div className="">
							<button type="button" className="btn orange-btn" onClick={this.siguientePregunta}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							Tu cuenta ha sido bloqueada temporalmente debido a varios intentos de inicio de sesión incorrectos. 
							Solicita tu verificación por SMS y recibe un código de verificación (OTP) para cambiar tu contraseña.
						</div>
						<div className='text-center aceptar-cancelar-btn mt-20'>
							<button type="button" className="btn orange-btn" onClick={this.goToPreguntas}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-user-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-user-bloqueadoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-user-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							Tu cuenta ha sido bloqueada temporalmente debido a varios intentos de inicio de sesión incorrectos. 
							Solicita tu verificación por SMS y recibe un código de verificación (OTP) para cambiar tu contraseña.
						</div>
						<div className='text-center aceptar-cancelar-btn mt-20'>
							<button type="button" className="btn orange-btn" onClick={this.goToLogin}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(IngresaContrasena);



// WEBPACK FOOTER //
// ./src/login/ingresaContrasena.cmpt.js